import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Avatar from './avatar';
import CoverImage from './cover-image';
import PostBody from './post-body';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import dayjs from 'dayjs';
export default function BlogPostPage(_ref) {
  var post = _ref.post;
  var lang = true ? window.navigator.language.includes('fr') ? 'fr' : 'en' : 'en';

  var _useTranslation = useTranslation(),
      i18n = _useTranslation.i18n,
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h1", {
      className: "mb-12 text-2xl font-bold leading-tight tracking-tighter text-center xl:text-6xl md:text-7xl lg:text-8xl md:leading-none md:text-left",
      children: post === null || post === void 0 ? void 0 : post.title
    }), /*#__PURE__*/_jsx("div", {
      className: "mb-2 lg:mb-8 sm:mx-0",
      children: /*#__PURE__*/_jsx(CoverImage, {
        post: post
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "hidden px-24 md:block md:mb-12",
      children: [/*#__PURE__*/_jsx(Avatar, {
        post: post
      }), /*#__PURE__*/_jsx("div", {
        className: "py-2 mb-4 text-sm font-semibold text-gray-500",
        children: dayjs(post === null || post === void 0 ? void 0 : post.date_created).locale(lang).format('dddd DD MMMM YYYY')
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "max-w-3xl mx-auto",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "block mb-6 md:hidden",
        children: [/*#__PURE__*/_jsx(Avatar, {
          post: post
        }), /*#__PURE__*/_jsx("div", {
          className: "py-2 mb-4 text-sm font-semibold text-gray-500",
          children: dayjs(post === null || post === void 0 ? void 0 : post.date_created).locale(lang).format('dddd DD MMMM YYYY')
        })]
      }), /*#__PURE__*/_jsx(PostBody, {
        content: post === null || post === void 0 ? void 0 : post.content
      })]
    })]
  });
}